import { NgModule } from '@angular/core';
import { TileItemDrawerService } from '../../dashboards/services/tile-item-drawer.service';
import { DataSourceItemsService } from '../../data-source/data-source-items/services/data-source-items.service';
import { processRequest } from './server';
import { validateOpenItemDrawerPayload, validateRequest } from './messages';

/** Include in AppModule - must be instantiated only ONCE! */
@NgModule()
export class CustomComponentRPCModule {
  constructor(
    dataSourceItemsService: DataSourceItemsService,
    tileItemDrawerService: TileItemDrawerService,
  ) {
    if (typeof self === 'undefined') {
      return;
    }

    const procedures = {
      getCount: ({ alias }) => dataSourceItemsService.getCount(alias),
      getPaginated: ({ alias, filters, datasourcefiltersId, sort, pagination }) => {
        const normalizedFilters =
          datasourcefiltersId && typeof datasourcefiltersId === 'string'
            ? {
                _id: datasourcefiltersId,
                query: { rules: [{}] },
              }
            : filters;

        return dataSourceItemsService.getPaginated(
          alias,
          normalizedFilters,
          sort,
          pagination ?? {
            pageIndex: 0,
            pageSize: 10,
          },
        );
      },
      getCustom: ({ alias, customEndpointAlias }) =>
        dataSourceItemsService.getCustom(alias, customEndpointAlias),
      openItemDrawer: (payload) => {
        const sanitizedPayload = validateOpenItemDrawerPayload(payload);
        tileItemDrawerService.open(sanitizedPayload);
        return null;
      },
    };

    self.addEventListener('message', async (event) => {
      try {
        const request = validateRequest(event.data);
        const result = await processRequest(procedures, request);
        (event.source.postMessage as any)(result, '*'); // TODO: we need to specify origin to improve security
      } catch {}
    });
  }
}
